import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
	'es': {
		descuentoAplicado:'Descuento aplicado',
		eligeSitioIdeal:"Elige tu sitio ideal para aparcar",
		tiempoTextoTooltip:'Tiempo para realizar la reserva',
		tituloFinReserva:'¡Tiempo para reservar agotado!',
		textoFinReserva:'Tu plaza ha sido liberada, has excedido el tiempo para reservar una plaza. Por favor, si finalmente quieres reservar, vuelve a rellenar los datos.',
		tiempoRestante:'Tiempo para reservar: ',
		serviciosPagoTarjeta:'PAGO CON TARJETA',
		serviciosAbierto:'ABIERTO 365/24h',
		servicioCargaBateria:'SERVICIO CARGA BATERIA',
		servicioLecturaMatricula:'LECTOR DE MATRICULA',
		serviciosPlazasAmplias:'PLAZAS AMPLIAS',
		losMasBaratos: 'SOMOS LOS MAS BARATOS DE LA ZONA',
		contactoSB: 'En Parking Luna de Granada disponemos de múltiples servicios pensados para tu comodidad. Contamos con 450 plazas de grandes dimensiones, sistema de guiado de plazas disponibles y ocupadas, espacios amplios y accesibles para todo tipo de vehículos, puntos de recarga para vehículos eléctricos, plazas para personas con movilidad reducida, sistema de vigilancia 24 horas que garantiza la protección de tu vehículo en todo momento. ',
		contactoSB2: 'También ofrecemos diferentes bonos y tarifas adaptados a tus necesidades para que puedas elegir el mejor plan para ti.',
		contactoSB3: ' Facilitamos tus desplazamientos al máximo con óptimas SALIDAS /ENTRADAS de vehículos. Estamos situados en Plaza Manuel Cano, 2, junto a la salida de la Autovía “Méndez Núñez” de la A-44.',
		tituloFraude: 'Fallo al obtener los datos de pago',
		descripcionFraude: 'Hemos detectado un fallo al obtener datos del pago. Vuelva a intertarlo por favor.',
		codigoPromocionalValido: 'Código promocional valido',
		codigoPromocionalUsado: 'Límite maximo de usos de este código.',
		codigoPromocionalCaducado: 'Código promocional no valido, este código esta caducado',
		codigoPromocionalMinimo: 'Codigo promocional valido, para activarlo es necesario realizar un reserva con mas dias.',
		codigoPromocionalNoValido: 'Código promocional incorrecto.',
		descuentoCodigoPromocional: 'Descuento',
		tienesCodigoPromocional: 'Usar código promocional',
		datosReservaPromocion: 'Código promocional',
		btnVolver: "Volver",
		fechaAnterior: "Fecha de entrada incorrecta",
		fechaAnteriorDescripcion: "La fecha de entrada seleccionada es anterior a la hora actual. Por favor rellena correctamente los campos.",
		contactoUnio: "Central Parking Ramblas es un Parking cubierto en el centro de Barcelona con 94 plazas disponibles, divididas en 4 plantas y abierto 24 horas con vigilancia. Está situado a un paso de la Rambla exactamente a 60 metros, entre el Raval y el Barrio Gótico de Barcelona y entre otros sitios de interés podremos encontrar a 2 minutos a pie el Gran Teatre del Liceu, a 120 metros del Palau Guell a 400 metros de Mercat de la Boqueria, a 3 minutos a pie de la Plaza Real y a 2 km de la playa.",
		contactoGV: "En Parking Luna Centro disponemos de múltiples servicios pensados para tu comodidad. Contamos con grandes dimensiones, espacios amplios y accesibles para todo tipo de vehículos, puntos de recarga para vehículos eléctricos, plazas para personas con movilidad reducida, sistema de vigilancia 24 horas que garantiza la protección de tu vehículo en todo momento.",
		contactoGVTurismo: "Facilitamos tus desplazamientos al máximo con óptimas SALIDAS /ENTRADAS de vehículos. Estamos situados en pleno centro de Granada en C/ San Isidro 3, con acceso por C/ San Antón.",
		ascensor: 'Ascensor',
		completo: "Parking Completo",
		completoDescripcion: "No se puede reservar porque el parking esta completo en el rango de fechas seleccionado. Por favor, selecciona otras fechas. ",
		proximamenteAbierto: "Proximamente abierto",
		fechasIncorrectas: "Fechas incorrectas",
		fechasIncorrectasDescripcion: "Has introducido las fechas incorrectamente. La fecha de salida no puede ser inferior a la fecha de entrada, restablecemos las fechas.",
		falloCurriculum: "Fallo al enviar el curriculum",
		falloCurriculumDescripcion: "Rellena correctamente todos los datos para enviar el curriculum",
		envioCorrecto: "Envio correcto",
		envioCorrectoDescripcion: "Se ha enviado el curriculum correctamente.",
		nombre: 'Nombre',
		apellidos: "Apellidos",
		telefono: "Telefono",
		adjuntaCurriculum: "Adjunta tu curriculum",
		enviar: "Enviar",
		cerrar: "Cerrar",
		proximamente: "Proximamente",
		rellenaElFormulario: 'Rellena el siguiente formulario',
		quieresTrabajar: "¿Quieres trabajar con nosotros?",
		servicios: "Servicios",
		labelCiudadSeleccionada: "Ciudad seleccionada",
		labelParkingSeleccionado: "Parking seleccionado",
		errorCaracteresMatricula: 'Solo letras y números',
		ciudad: 'Ciudad',
		accede: "Clica aquí.",
		trabajaconnosotros: 'Trabaja con nosotros',
		labelInicio: '¿Donde te encuentras?',
		labelInicioDondeQuieresAparcar: '¿Donde quieres aparcar?',
		terminosPrivacidadCurriculum: 'Acepta los términos de privacidad',
		eligeCiudad: 'Elige la ciudad',
		eligeParking: 'Elige el parking',
		nuestrosParking: 'Nuestros Parkings',
		reglasInicio: 'Necesitas introducir este valor para continuar',
		errorObteniendoDisponibilidad: 'Error obteniendo la disponibilidad de plazas.',
		plazasNoDiponibles: 'No hay plazas disponibles para las fechas marcadas.',
		obtenerFactura: 'Obtener factura',
		cancelarReserva: 'Cancelar reserva',
		avisolegal: 'Términos del servicio',
		politicaprivacidad: 'Política de Privacidad',
		palacioreal: 'Palacio Real',
		pagoseguro: 'Pago seguro con',
		contacto1: 'Parking Luna de Granada',
		contacto2: 'Parking Luna centro',
		contacto3: 'Parking Uniò 7',
		copyright: 'Creado por',
		horario: 'Lunes a domingo 24 horas',
		comollegar: 'CÓMO LLEGAR',
		minutos: 'minutos',
		informacionParking: 'Información del parking',
		parking: 'Parking Seleccionado',
		telefonoBarcelona: ' 682 90 31 74 - 619 43 08 39',
		correoParkingUnio: ' lunadegranada@delunaparking.com',
		correoParkingGranVia: ' lunadegranada@delunaparking.com',
		dia: 'día',
		dias: 'días',
		duracion: 'Duración',
		importe: 'Importe',
		datosReservaTitulo: 'COMPLETA TU RESERVA',
		datosReservaFechaEntrada: 'Fecha de entrada',
		datosReservaFechaSalida: 'Fecha de Salida',
		datosReservaMatricula: 'Matrícula',
		datosReservaModelo: 'Modelo del vehículo',
		datosReservaColor: 'Color del vehículo',
		datosReservaPrecioTotal: 'Reserva de parking:',
		datosReservaTotal: 'Total',
		datosReservaNombre: 'Nombre completo',
		datosReservaEmail: 'Email',
		datosReservaTelefono: 'Teléfono',
		datosReservaAceptoCondiciones: 'Acepto los términos y condiciones del servicio',
		datosReservaInformacionFacturacion: 'Datos de facturación',
		datosReservaNombreFac: 'Nombre',
		datosReservaCif: 'CIF',
		datosReservaDireccion: 'Dirección',
		datosReservaLocalidad: 'Localidad',
		datosReservaCp: 'Código postal',
		datosReservaLocalizador: 'Localizador',
		datosReservaQR: 'Código QR',
		miReservaTitulo: 'Datos de la reserva',
		errorNoNombre: 'Campo obligatorio',
		errorNoEmail: 'Campo obligatorio',
		errorEmailErroneo: 'Introduzca un email válido',
		errorNoAceptaTerminos: 'Campo obligatorio',
		errorNoTelefono: 'Campo obligatorio',
		errorNoFechaEntrada: 'Campo obligatorio',
		errorNoFechaSalida: 'Campo obligatorio',
		errorNoMatricula: 'Campo obligatorio',
		errorNoModelo: 'Campo obligatorio',
		errorNoColor: 'Campo obligatorio',
		errorNoCrucero: 'Campo obligatorio',
		errorNoLocalizador: 'Campo Obligatorio',
		errorReservaNoEncontrada: 'Reserva no encontrada',
		btnBuscarReserva: 'Buscar reserva',
		btnReservar: 'Reservar',
		btnTerminar: 'Terminar',
		btnImprimir: 'Imprimir',
		btnContinuar: 'Continuar',
		btnCancelar: 'Cancelar',
		btnSolicitarFactura: 'Solicitar factura',
		fechaFinalErronea: 'Fecha final errónea',
		reservaMayorPermitido: 'La reserva supera la duración máxima permitida (14 días)',
		datosReservaHoraEntrada: '',
		datosReservaHoraSalida: '',
		lugaresInteres: 'Puntos cercanos',
		descripcionParking: 'Descripción',
		descripcionParkingP1: 'Bienvenido a deLuna Parking, un lugar donde podrás estacionar tu vehículo con total tranquilidad. Nuestros parkings cuentan con una ubicación privilegiada, lo que significa que estarás cerca de todo lo que necesitas en la ciudad, y además de ello, contamos con plazas eléctricas para aquellos que se preocupan por el medio ambiente. ',
		descripcionParkingP2: 'deLuna Parking es un lugar seguro para dejar tu vehículo, las 24 horas del día, los 7 días de la semana. Además, ofrecemos facilidad de acceso y una gran variedad de opciones de estacionamiento, lo que hace que sea fácil para ti encontrar el lugar perfecto para aparcar.',
		descripcionParkingP3: 'Con nuestras plazas eléctricas, podrás cargar tu vehículo mientras estás fuera, lo que te permitirá salir con la tranquilidad de tener una batería completamente cargada.',
		descripcionParkingP4: 'Si estás buscando un lugar seguro y cómodo para aparcar tu vehículo en la ciudad, nuestro servicio de estacionamiento con atención 24 horas es la mejor opción para ti.',
		descripcionParkingP5:'Ofrecemos una excelente ubicación, seguridad y comodidad, todo en un solo lugar. ¡Te esperamos!',
		presentacionDireccion: 'Dirección',
		presentacionHorario: 'Horarios',
		presentacionServicios: 'Servicios',
		presentacionPubli: 'Reserva online tu aparcamiento en el centro Granada',
		presentacionInfo:'Del 03.07 al domingo 07.07, el parking sólo podrá utilizarse desde la 07:00 a las 15:00.',
		presentacionAccesos: 'Accesos y salidas',
		presentacionDias: 'Lunes a domingo 24 horas',
		presentacionDireccionParking: 'Detrás Terminal E - HELIX, Moll Adossat, 08039, Barcelona',
		stepperComprobarDatos: 'TUS DATOS',
		steperRealizarPago: 'PAGO',
		stepperResultadoProceso: 'RESULTADO',
		resumenTitulo: 'Resumen de reserva',
		resumenPrecio: 'PRECIO',
		resumenSubTotal: 'Subtotal',
		resumenTotal: 'TOTAL',
		resumenPieCancelacion: 'Cancelación gratuita 24 horas antes.',
		resumenPieGarantia: 'Plaza de parking garantizada.',
		resumenAvisoDevolucion: 'El importe se abonará en la misma tarjeta utilizada en el pago',
		resumenImporteAbonado: 'Importe abonado',
		condicionesUso: 'Condiciones de Servicios',
		politicaDevolucion: 'Política de Cancelación y Reembolso',
		trabajaConNosotros: 'Trabaja con nosotros',
		barcelona: 'Barcelona',
		madrid: 'Madrid',
		y: 'y',
		resumenAvisoCorreo: 'Recibirás un email con todos los detalles de tu reserva.',
		resumenAvisoCorreoFactura: 'Recibirás un email con tu factura.',
		resumenContacto: 'En caso de que quiera realizar una anulación o un cambio de fecha recuerde que es completamente GRATUITO, envíe un mail a cpunio@smartrental.com ',
		stepperContinuarPago: 'Aceptar condicones y continuar con el pago',
		inicioBienvenido: 'BIENVENIDOS A',
		inicioNombreParking: 'deLuna Parking',
		inicioSomosUnicos: 'SOMOS EL PARKING MAS ACCESIBLE Y ECONOMICO DEL CENTRO DE MADRID',
		inicioPrecioSemana: '7 días por solo 68€',
		inicioReservarPlaza: 'Reservar una plaza',
		inicioPlazaGarantizada: 'Reservando un plaza con nosotros, tu parking está garantizado.',
		inicioCancelacionReembolso: 'Si necesitas cancelar tu reserva, podrás hacerlo con opción a reembolso hasta 24 horas antes.',
		inicioAhorra: 'Ahorra con tarifas competitivas para estancia corta y larga.',
		inicioTituloPlazaGarantizada: 'Tu plaza está garantizada',
		inicioTituloCancelacionReembolso: 'Cancelación con reembolso',
		inicioTituloAhorra: 'Ahorra en parking',
		inicioConsulteRestricciones: 'Consulte Restricciones',
		inicioZBE: 'Zona de Bajas Emisiones',
		menuReservar: 'Reservar',
		menuFaq: 'FAQS',
		menuFuncionamiento: '¿Cómo funciona?',
		menuContacto: 'Contacto',
		menuNuestrosParkings: 'Nuestros parkings',
		menuCancelar: 'Cancelar reserva',
		errorNoCP: 'Rellena el CP',
		errorNoLocalidad: 'Rellena la localidad',
		errorNoDireccion: 'Rellena la dirección',
		errorNoCIF: 'Rellena el CIF',
		errorNoNombreFac: 'Rellena el nombre de la factura',
		servicioAireLibre: 'Descubierto y abierto 24 horas',
		servicioCodigoQr: 'Lector de matrículas y código QR',
		servicioVideoVigilancia: 'SEGURIDAD 24h',
		electrico: 'PUNTO DE RECARGA',
		atencion: 'Atención 24 horas *',
		pago: 'Pago contacless, Tarjeta y Efectivo',
		servicioAlturaMaxima: 'Altura máxima 2,4m',
		servicioZbe: 'Zona de bajas emisiones',
		servicioZbeBarcelona: 'Zona de bajas emisiones en Barcelona',
		servicioZbeMadrid: 'Zona de bajas emisiones en Madrid',
		servicioPlazasMinusvalidos: 'ACCESO ADAPTADO',
		aseos: 'Aseos',
		servicioCancelacionReserva: 'Cancelación gratuita hasta 24 horas antes del inicio de la reserva (*  solo parkings de Madrid).',
		descripcionZBEMadrid3: 'Accede aqui para consultar la restricciones que pueda tener tu vehiculo. ',
		descripcionZBEMadrid1: 'La Zona de Bajas Emisiones de Especial Protección (ZBEDEP) “Distrito Centro” fue creada en desarrollo de la Estrategia de Sostenibilidad Ambiental Madrid 360, para proteger la salud humana y el medio ambiente urbano mediante la mejora de la calidad del aire y la disminución de los efectos negativos del tráfico motorizado',
		descripcionZBEMadrid2: 'A estos efectos, se prohíbe el acceso a los vehículos con clasificación ambiental "A" (y que, por tanto, no pueden obtener distintivo ambiental), en tanto que los vehículos con clasificación ambiental "B" y "C" tienen prohibido acceder a la ZBEDEP "Distrito Centro" únicamente para atravesarla, si bien podrán hacerlo para estacionar en un aparcamiento de uso público o privado, o reserva de estacionamiento situados en su interior. En todo caso, los criterios de acceso prevén determinadas excepciones, que afectan a residentes, empresas y autónomos, personas con movilidad reducida, servicios públicos, transporte de alumnado a centros educativos y otros colectivos y supuestos.',
		descripcionZBE1: 'Les informamos que desde el 1 de enero el Ayuntamiento de Barcelona ha puesto en funcionamiento la nueva zona de bajas emisiones (ZBE) que restringe la circulación de ciertos vehículos por la ciudad. Es por este motivo que para acceder a nuestro estacionamiento tendrán que comprobar si su vehículo (matrícula nacional o extranjera) está autorizado para poder circular en esta zona.',
		descripcionZBE2: 'Adjuntamos el link de la página oficial del Ayuntamiento de Barcelona, para que puedan acceder a toda la información donde podrán registrarse en caso de ser necesario.',
		preguntasFrecuentes: 'Preguntas frecuentes',
		pregunta1: '¿ Que descuentos puedes conseguir con los BONOS ESTANCIAS ESPECIALES ? ',
		pregunta1Parrafo1: 'Para estancias especiales de FORMA CONTINUADA, tenemos BONOS ESPECIALES adaptados a ti con descuentos de hasta un 70%.',
		pregunta2: '¿ Que descuentos puedes conseguir con nuestras tarjetas prepago BONOPARKING ? ',
		pregunta2Parrafo1: 'Si eres USUARIO HABITUAL de nuestras instalaciones aprovéchate de nuestros descuentos de hasta un 60% sobre Tarifas / Hora y benefíciate de la comodidad de tener la tarjeta BONOPARKING.',
		pregunta3: '¿ Qué descuentos puedes conseguir comprando tickets para tu negocio?',
		pregunta3Parrafo1: 'Para empresas o comercios ASOCIADOS a nuestro parking. Ofrece a tus CLIENTES PARKING GRATUITO beneficiándote de descuentos de hasta un 55% por la compra de horas gratuitas para sus clientes.',
		pregunta4: '¿Puedo retirar el coche más tarde de la hora que tenía reservada?',
		pregunta4Parrafo1: 'Si, sólo tendrá que abonar la diferencia, pues el comprobante no le funcionará, y siempre sujeto a disponibilidad.',
		pregunta5: 'Si llego antes de la hora reservada, ¿voy a poder entrar?',
		pregunta5Parrafo1: ' Por supuesto, siempre y cuando haya disponibilidad.',
		pregunta6: '¿ Qué descuentos puedes conseguir a través de nuestros convenios ?',
		pregunta6Parrafo1: 'Descuentos sobre tarifas de hasta un 25% en distintos BONOS o en PUBLICIDAD para su negocio, a través de nuestros CONVENIOS de COLABORACIÓN con empresas, comercios y entidades.',
		pregunta7: '¿ Como beneficiarte de nuestros espacios comerciales para publicidad ?',
		pregunta7Parrafo1: 'Te ofrecemos ESPACIOS COMERCIALES para la publicidad de tu empresa o comercio. Benefíciate del impacto comercial y económico que supone ser visto por más de 500.000 personas al año..',
		pregunta8: '¿Hay estación de recarga eléctrica?',
		pregunta8Parrafo1: 'Si, puede usted cargar su vehículo aquí.',
		pregunta9: '¿Hay servicio de limpieza?',
		pregunta9Parrafo1: 'Si, puede usted limpiar su vehículo por 30 €, siempre y cuando haya disponibilidad.',
		pregunta10: '¿Cómo puedo reservar mi plaza?',
		pregunta10Parrafo1: 'A través de nuestra web o a través de la APP ""',
		pregunta11: '¿Que métodos de pago?',
		pregunta11Parrafo1: 'Únicamente podrá pagar a través de nuestra web o con tarjeta de crédito en nuestras máquinas habilitadas para ello.',
		pregunta12: '¿Puedo aparcar mi moto??',
		pregunta12Parrafo1: 'Si, la tarifa es igual a la de un turismo.',
		reservaConfirmada: 'RESERVA CONFIRMADA',
		infoTiempoCortesia: 'Dispondrá de un margen de entrada/salida de una hora respecto al tiempo efectivo de reserva.',
		tablaTarifaDiaPorHoras: 'Un día',
		tablaTarifaHoras: 'Una hora',
		tablaTarifaHorasTitulo: 'Tarifa estándar de estacionamiento',
		tablaTarifaHorasPrecio: 'Precio',
		reservaCancelada: 'La reserva ha sido cancelada y su importe abonado en la tarjeta de crédito',
		datosReservaTarjeta: 'Tarjeta de crédito',
		errorPlazoCancelacion: 'Su reserva empieza en menos de 1 día y no puede ser cancelada por este medio.',
		funcionamientoEstancia: 'Define el periodo de reserva',
		funcionamientoDatosPersonales: 'Identifícate',
		funcionamientoDatosFacturacion: '¿Necesitarás una factura?',
		funcionamientoPago: 'Realiza el pago de la reserva',
		funcionamientoReservaRealizada: 'Enhorabuena, has terminado tu reserva.',
		funcionamientoCancelarReserva: '¿Deseas cancelar tu reserva?',
		funcionamientoP1P1: 'Introduce los datos que definen el periodo de la reserva (día/hora de entrada y día/hora de salida), la información del vehículo que vas a utilizar (número de matrícula, modelo).',
		funcionamientoP1P2: 'Nuestra web te informará del importe a pagar para el periodo de tiempo introducido. Quizás te aparezca un aviso en caso de que la fecha de salida no sea posterior a la de entrada.',
		funcionamientoP1P3: 'Pulsa el botón "RESERVAR" para continuar con el proceso.',
		funcionamientoP1P4: '',
		funcionamientoP2P1: 'Necesitamos conocer una información mínima sobre ti, de esta manera podremos tener un canal de comunicación contigo e identificarte en caso de que necesites realizarnos alguna consulta.',
		funcionamientoP3P1: 'Si crees que necesitarás una factura nominativa de tu estancia, introduce los datos fiscales de facturación. No es obligatorio.',
		funcionamientoP4P1: 'En pantalla verás un formulario para introducir los datos de la tarjeta con la que vas a realizar el pago.',
		funcionamientoP4P2: 'Este formulario es totalmente seguro y cumple con la normativa vigente para pagos por internet. Central Parkings no tiene acceso a los datos de tu tarjeta, ya que se trata de una comunicación directa y blindada con la pasarela de pagos.',
		funcionamientoP5P1: 'Si el proceso de pago concluye correctamente verás esta pantalla de confirmación de reserva.',
		funcionamientoP5P2: 'Los datos más relevantes son el código del localizador de la reserva y el código QR que te servirá para acceder al parking en caso de que hubiera algún problema con el sistema automático de lectura de matrícula.',
		funcionamientoP5P3: 'Recibirás un email con los datos de la reserva. Te recomendamos que conserves este mail por si te lo solicitasen los empleados del parking.',
		funcionamientoP6P1: 'Si faltan mas de 24 horas hasta el momento de inicio de tu reserva, puedes cancelarla de manera automática y gratuita.',
		funcionamientoP6P2: 'Pulsa el botón "CANCELAR RESERVA" que encontrarás en la barra de menú de la página. Cuando lo hagas aparecerá una ventana para que introduzcas tu email y el número de localizador de la reserva. Con estos datos podremos recuperar toda la información necesaria.',
		funcionamientoP6P3: 'Si estás en plazo de cancelación y has introducido correctamente los datos, se te mostrará toda la información asociada a la reserva: Fecha y hora de inicio, fecha y hora de finalización importe pagado, etc. Pulsando el boton "CANCELAR" se anulará la reserva en el parking y se te devolverá el importe pagado en tu tarjeta de crédito.',
		reservaTuPlaza: 'Reserva tu plaza',
		mensajeCookies: 'Utilizamos cookies propias y de terceros para mejorar la experiencia de usuario y mejorar nuestros servicios. Si acepta o continúa navegando, consideramos que acepta su uso.',
		enlaceCookies: 'Política de cookies',
		aceptarCookies: 'Acepto',
		accionesReserva: 'Mis reservas',
		reviseSuCorreo: 'Recibirá un email con la factura',
		correoParkingSanBernardo: ' lunadegranada@delunaparking.com'
	},	// fin traduccion a español

	'en':{
		descuentoAplicado:'Discount applied',
		eligeSitioIdeal:"Choose your ideal parking spot",
		reservaTuPlaza: 'Reserve your place',
		tiempoTextoTooltip:'Time to make the reservation',
		tituloFinReserva: 'Reservation time expired!',
		textoFinReserva: 'Your parking spot has been released, you have exceeded the reservation time. Please, if you still wish to reserve, fill in the details again.',
		tiempoRestante: 'Time to reserve: ',
		serviciosPagoTarjeta: 'PAY WITH CARD',
		serviciosAbierto: 'OPEN 365/24h',
		servicioCargaBateria: 'BATTERY CHARGING SERVICE',
		servicioLecturaMatricula: 'LICENSE PLATE READER',
		serviciosPlazasAmplias: 'SPACIOUS PARKING SPOTS',
		losMasBaratos: 'WE ARE THE CHEAPEST IN THE AREA',
		contactoSB: 'At Parking Luna de Granada, we offer multiple services designed for your comfort. We have 450 large parking spaces, a guidance system for available and occupied spots, spacious and accessible areas for all types of vehicles, charging stations for electric vehicles, parking spaces for people with reduced mobility, and a 24-hour surveillance system that guarantees the protection of your vehicle at all times. ',
		contactoSB2: 'We also offer various packages and rates adapted to your needs so that you can choose the best plan for you.',
		contactoSB3: 'We facilitate your movements to the maximum with optimal VEHICLE EXITS/ENTRIES. We are located at Plaza Manuel Cano, 2, next to the exit of the “Méndez Núñez” motorway on the A-44.',
		tituloFraude: 'Failed to obtain payment details',
		descripcionFraude: 'We have detected an error retrieving the payment data. Please try again.',
		codigoPromocionalValido: 'Valid promotional code',
		codigoPromocionalUsado: 'Maximum usage limit for this code.',
		codigoPromocionalCaducado: 'Invalid promotional code, this code has expired',
		codigoPromocionalMinimo: 'Valid promotional code, to activate it you need to make a reservation for more days.',
		codigoPromocionalNoValido: 'Incorrect promotional code.',
		descuentoCodigoPromocional: 'Discount',
		tienesCodigoPromocional: 'Use promotional code',
		datosReservaPromocion: 'Promotional code',
		btnVolver: 'Back',
		fechaAnterior: 'Incorrect check-in date',
		fechaAnteriorDescripcion: 'The selected check-in date is earlier than the current time. Please fill in the fields correctly.',
		contactoUnio: 'Central Parking Ramblas is an indoor parking facility in the center of Barcelona with 94 spaces available, divided into 4 levels and open 24 hours with surveillance. It is located just 60 meters from La Rambla, between El Raval and the Gothic Quarter of Barcelona, and among other points of interest, you can find the Gran Teatre del Liceu 2 minutes on foot, Palau Güell 120 meters away, Mercat de la Boqueria 400 meters away, Plaça Reial 3 minutes on foot, and the beach 2 km away.',
		contactoGV: 'At Parking Luna Centro, we offer multiple services designed for your comfort. We feature large dimensions, spacious and accessible areas for all types of vehicles, charging points for electric vehicles, parking spaces for people with reduced mobility, and a 24-hour surveillance system that guarantees the protection of your vehicle at all times.',
		contactoGVTurismo: 'We facilitate your journeys to the fullest with optimal VEHICLE EXITS/ENTRIES. We are located in the heart of Granada at C/ San Isidro 3, with access via C/ San Antón.',
		ascensor: 'Elevator',
		completo: 'Parking Full',
		completoDescripcion: 'Reservation cannot be made because the parking is full for the selected dates. Please select other dates. ',
		proximamenteAbierto: 'Opening soon',
		fechasIncorrectas: 'Incorrect dates',
		fechasIncorrectasDescripcion: 'You have entered the dates incorrectly. The departure date cannot be earlier than the entry date; we are resetting the dates.',
		falloCurriculum: 'Error sending resume',
		falloCurriculumDescripcion: 'Please fill in all the details correctly to send the resume',
		envioCorrecto: 'Submission successful',
		envioCorrectoDescripcion: 'The resume has been sent successfully.',
		nombre: 'Name',
		apellidos: 'Surname',
		telefono: 'Phone',
		adjuntaCurriculum: 'Attach your resume',
		enviar: 'Send',
		cerrar: 'Close',
		proximamente: 'Coming soon',
		rellenaElFormulario: 'Fill in the following form',
		quieresTrabajar: 'Do you want to work with us?',
		servicios: 'Services',
		labelCiudadSeleccionada: 'Selected city',
		labelParkingSeleccionado: 'Selected parking',
		errorCaracteresMatricula: 'Only letters and numbers',
		ciudad: 'City',
		accede: 'Click here.',
		trabajaconnosotros: 'Work with us',
		labelInicio: 'Where are you located?',
		labelInicioDondeQuieresAparcar: 'Where do you want to park?',
		terminosPrivacidadCurriculum: 'Accept the privacy terms',
		eligeCiudad: 'Choose the city',
		eligeParking: 'Choose the parking',
		nuestrosParking: 'Our Parkings',
		reglasInicio: 'You need to enter this value to continue',
		errorObteniendoDisponibilidad: 'Error obtaining parking availability.',
		plazasNoDiponibles: 'There are no spots available for the selected dates.',
		obtenerFactura: 'Get invoice',
		cancelarReserva: 'Cancel reservation',
		avisolegal: 'Terms of Service',
		politicaprivacidad: 'Privacy Policy',
		palacioreal: 'Royal Palace',
		pagoseguro: 'Secure payment with',
		contacto1: 'Parking Luna de Granada',
		contacto2: 'Parking Luna Centro',
		contacto3: 'Parking Uniò 7',
		copyright: 'Created by',
		horario: 'Monday to Sunday 24 hours',
		comollegar: 'HOW TO GET THERE',
		minutos: 'minutes',
		informacionParking: 'Parking information',
		parking: 'Selected parking',
		telefonoBarcelona: ' 682 90 31 74 - 619 43 08 39',
		correoParkingUnio: ' lunadegranada@delunaparking.com',
		correoParkingGranVia: ' lunadegranada@delunaparking.com',
		dia: 'day',
		dias: 'days',
		duracion: 'Duration',
		importe: 'Amount',
		datosReservaTitulo: 'COMPLETE YOUR RESERVATION',
		datosReservaFechaEntrada: 'Entry date',
		datosReservaFechaSalida: 'Exit date',
		datosReservaMatricula: 'License plate',
		datosReservaModelo: 'Vehicle model',
		datosReservaColor: 'Vehicle color',
		datosReservaPrecioTotal: 'Parking reservation:',
		datosReservaTotal: 'Total',
		datosReservaNombre: 'Full name',
		datosReservaEmail: 'Email',
		datosReservaTelefono: 'Phone',
		datosReservaAceptoCondiciones: 'I accept the terms and conditions of the service',
		datosReservaInformacionFacturacion: 'Billing information',
		datosReservaNombreFac: 'Name',
		datosReservaCif: 'Tax ID',
		datosReservaDireccion: 'Address',
		datosReservaLocalidad: 'City',
		datosReservaCp: 'Postal code',
		datosReservaLocalizador: 'Reservation code',
		datosReservaQR: 'QR Code',
		miReservaTitulo: 'Reservation details',
		errorNoNombre: 'Required field',
		errorNoEmail: 'Required field',
		errorEmailErroneo: 'Enter a valid email',
		errorNoAceptaTerminos: 'Required field',
		errorNoTelefono: 'Required field',
		errorNoFechaEntrada: 'Required field',
		errorNoFechaSalida: 'Required field',
		errorNoMatricula: 'Required field',
		errorNoModelo: 'Required field',
		errorNoColor: 'Required field',
		errorNoCrucero: 'Required field',
		errorNoLocalizador: 'Required field',
		errorReservaNoEncontrada: 'Reservation not found',
		btnBuscarReserva: 'Search reservation',
		btnReservar: 'Reserve',
		btnTerminar: 'Finish',
		btnImprimir: 'Print',
		btnContinuar: 'Continue',
		btnCancelar: 'Cancel',
		btnSolicitarFactura: 'Request invoice',
		fechaFinalErronea: 'Incorrect end date',
		reservaMayorPermitido: 'The reservation exceeds the maximum allowed duration (14 days)',
		datosReservaHoraEntrada: '',
		datosReservaHoraSalida: '',
		lugaresInteres: 'Nearby points',
		descripcionParking: 'Description',
		descripcionParkingP1: 'Welcome to deLuna Parking, a place where you can park your vehicle with complete peace of mind. Our parking facilities are ideally located, meaning you will be close to everything you need in the city, and in addition, we have electric charging spots for those who care about the environment. ',
		descripcionParkingP2: 'deLuna Parking is a safe place to leave your vehicle, 24 hours a day, 7 days a week. In addition, we offer easy access and a wide variety of parking options, making it easy for you to find the perfect spot to park.',
		descripcionParkingP3: 'With our electric charging spots, you can charge your vehicle while you\'re away, allowing you to leave with the peace of mind of a fully charged battery.',
		descripcionParkingP4: 'If you are looking for a safe and comfortable place to park your vehicle in the city, our 24-hour parking service is the best option for you.',
		descripcionParkingP5: 'We offer an excellent location, security, and comfort, all in one place. We look forward to welcoming you!',
		presentacionDireccion: 'Address',
		presentacionHorario: 'Opening hours',
		presentacionServicios: 'Services',
		presentacionPubli: 'Reserve your parking online in downtown Granada',
		presentacionInfo: 'From July 3 to Sunday July 7, the parking can only be used from 07:00 to 15:00.',
		presentacionAccesos: 'Access and exits',
		presentacionDias: 'Monday to Sunday 24 hours',
		presentacionDireccionParking: 'Behind Terminal E - HELIX, Moll Adossat, 08039, Barcelona',
		stepperComprobarDatos: 'YOUR DETAILS',
		steperRealizarPago: 'PAYMENT',
		stepperResultadoProceso: 'RESULT',
		resumenTitulo: 'Reservation summary',
		resumenPrecio: 'PRICE',
		resumenSubTotal: 'Subtotal',
		resumenTotal: 'TOTAL',
		resumenPieCancelacion: 'Free cancellation 24 hours in advance.',
		resumenPieGarantia: 'Guaranteed parking spot.',
		resumenAvisoDevolucion: 'The amount will be refunded to the same card used for payment',
		resumenImporteAbonado: 'Amount paid',
		condicionesUso: 'Service conditions',
		politicaDevolucion: 'Cancellation and Refund Policy',
		trabajaConNosotros: 'Work with us',
		barcelona: 'Barcelona',
		madrid: 'Madrid',
		y: 'and',
		resumenAvisoCorreo: 'You will receive an email with all the details of your reservation.',
		resumenAvisoCorreoFactura: 'You will receive an email with your invoice.',
		resumenContacto: 'In case you wish to cancel or change the date, remember that it is completely FREE; please send an email to cpunio@smartrental.com ',
		stepperContinuarPago: 'Accept conditions and continue with payment',
		inicioBienvenido: 'WELCOME TO',
		inicioNombreParking: 'deLuna Parking',
		inicioSomosUnicos: 'WE ARE THE MOST ACCESSIBLE AND AFFORDABLE PARKING IN THE CENTER OF MADRID',
		inicioPrecioSemana: '7 days for only 68€',
		inicioReservarPlaza: 'Reserve a spot',
		inicioPlazaGarantizada: 'By reserving a spot with us, your parking is guaranteed.',
		inicioCancelacionReembolso: 'If you need to cancel your reservation, you can do so with a refund option up to 24 hours in advance.',
		inicioAhorra: 'Save with competitive rates for short and long stays.',
		inicioTituloPlazaGarantizada: 'Your spot is guaranteed',
		inicioTituloCancelacionReembolso: 'Refundable cancellation',
		inicioTituloAhorra: 'Save on parking',
		inicioConsulteRestricciones: 'Check Restrictions',
		inicioZBE: 'Low Emission Zone',
		menuReservar: 'Reserve',
		menuFaq: 'FAQS',
		menuFuncionamiento: 'How does it work?',
		menuContacto: 'Contact',
		menuNuestrosParkings: 'Our parkings',
		menuCancelar: 'Cancel reservation',
		errorNoCP: 'Fill in the postal code',
		errorNoLocalidad: 'Fill in the locality',
		errorNoDireccion: 'Fill in the address',
		errorNoCIF: 'Fill in the Tax ID',
		errorNoNombreFac: 'Fill in the invoice name',
		servicioAireLibre: 'Open-air and open 24 hours',
		servicioCodigoQr: 'License plate and QR code reader',
		servicioVideoVigilancia: '24h SECURITY',
		electrico: 'CHARGING STATION',
		atencion: '24-hour service *',
		pago: 'Contactless, Card, and Cash Payment',
		servicioAlturaMaxima: 'Maximum height 2.4m',
		servicioZbe: 'Low Emission Zone',
		servicioZbeBarcelona: 'Low Emission Zone in Barcelona',
		servicioZbeMadrid: 'Low Emission Zone in Madrid',
		servicioPlazasMinusvalidos: 'Disabled access',
		aseos: 'Restrooms',
		servicioCancelacionReserva: 'Free cancellation up to 24 hours before the reservation starts (* Madrid parkings only).',
		descripcionZBEMadrid3: 'Click here to check the restrictions that may apply to your vehicle.',
		descripcionZBEMadrid1: 'The Special Protection Low Emission Zone (ZBEDEP) "Distrito Centro" was created as part of the Madrid 360 Environmental Sustainability Strategy to protect human health and the urban environment by improving air quality and reducing the negative effects of motor traffic.',
		descripcionZBEMadrid2: 'For this purpose, access is prohibited for vehicles with environmental classification "A" (and therefore, which cannot obtain an environmental badge), while vehicles with classifications "B" and "C" are only prohibited from entering the ZBEDEP "Distrito Centro" to pass through it; however, they may do so to park in a public or private facility, or in reserved parking within it. In any case, the access criteria provide for certain exceptions that affect residents, businesses, self-employed individuals, people with reduced mobility, public services, transportation of students to educational centers, and other groups and situations.',
		descripcionZBE1: 'We inform you that since January 1st the Barcelona City Council has implemented the new Low Emission Zone (ZBE) that restricts the circulation of certain vehicles in the city. For this reason, to access our parking, you must verify whether your vehicle (domestic or foreign license plate) is authorized to circulate in this area.',
		descripcionZBE2: 'We have attached the link to the official Barcelona City Council website, so that you can access all the information and register if necessary.',
		preguntasFrecuentes: 'Frequently Asked Questions',
		pregunta1: 'What discounts can you get with the SPECIAL STAY VOUCHERS?',
		pregunta1Parrafo1: 'For continuous special stays, we offer SPECIAL VOUCHERS tailored to you with discounts of up to 70%.',
		pregunta2: 'What discounts can you get with our BONOPARKING prepaid cards?',
		pregunta2Parrafo1: 'If you are a regular user of our facilities, take advantage of our discounts of up to 60% on hourly rates and enjoy the convenience of having the BONOPARKING card.',
		pregunta3: 'What discounts can you get by purchasing tickets for your business?',
		pregunta3Parrafo1: 'For companies or businesses associated with our parking, offer your clients FREE PARKING while benefiting from discounts of up to 55% on the purchase of free parking hours for your customers.',
		pregunta4: 'Can I pick up the car later than the reserved time?',
		pregunta4Parrafo1: 'Yes, you will only have to pay the difference, as the ticket will not work, and always subject to availability.',
		pregunta5: 'If I arrive before the reserved time, will I be able to enter?',
		pregunta5Parrafo1: 'Of course, as long as there is availability.',
		pregunta6: 'What discounts can you get through our agreements?',
		pregunta6Parrafo1: 'Discounts on rates of up to 25% on various VOUCHERS or on ADVERTISING for your business, through our COLLABORATION AGREEMENTS with companies, businesses, and organizations.',
		pregunta7: 'How can you benefit from our commercial spaces for advertising?',
		pregunta7Parrafo1: 'We offer COMMERCIAL SPACES for the advertising of your company or business. Benefit from the commercial and economic impact of being seen by over 500,000 people a year.',
		pregunta8: 'Is there an electric charging station?',
		pregunta8Parrafo1: 'Yes, you can charge your vehicle here.',
		pregunta9: 'Is there a cleaning service?',
		pregunta9Parrafo1: 'Yes, you can have your vehicle cleaned for 30 €, subject to availability.',
		pregunta10: 'How can I reserve my spot?',
		pregunta10Parrafo1: 'Through our website or through the APP.',
		pregunta11: 'What payment methods?',
		pregunta11Parrafo1: 'You can only pay through our website or with a credit card on our designated machines.',
		pregunta12: 'Can I park my motorcycle?',
		pregunta12Parrafo1: 'Yes, the rate is the same as for a car.',
		reservaConfirmada: 'RESERVATION CONFIRMED',
		infoTiempoCortesia: 'You will have a one-hour grace period for check-in/check-out relative to the actual reservation time.',
		tablaTarifaDiaPorHoras: 'One day',
		tablaTarifaHoras: 'One hour',
		tablaTarifaHorasTitulo: 'Standard parking rate',
		tablaTarifaHorasPrecio: 'Price',
		reservaCancelada: 'The reservation has been cancelled and its amount has been charged to the credit card',
		datosReservaTarjeta: 'Credit card',
		errorPlazoCancelacion: 'Your reservation starts in less than 1 day and cannot be cancelled through this method.',
		funcionamientoEstancia: 'Define the reservation period',
		funcionamientoDatosPersonales: 'Identify yourself',
		funcionamientoDatosFacturacion: 'Will you need an invoice?',
		funcionamientoPago: 'Make the reservation payment',
		funcionamientoReservaRealizada: 'Congratulations, you have completed your reservation.',
		funcionamientoCancelarReserva: 'Do you want to cancel your reservation?',
		funcionamientoP1P1: 'Enter the details that define the reservation period (entry date/time and exit date/time), and the information of the vehicle you will use (license plate number, model).',
		funcionamientoP1P2: 'Our website will inform you of the amount to be paid for the specified period. A warning may appear if the exit date is not later than the entry date.',
		funcionamientoP1P3: 'Click the "RESERVE" button to continue with the process.',
		funcionamientoP1P4: '',
		funcionamientoP2P1: 'We need to know some basic information about you, so we can have a channel of communication and identify you if you need to make any inquiries.',
		funcionamientoP3P1: 'If you think you will need a personalized invoice for your stay, enter the billing information. It is not mandatory.',
		funcionamientoP4P1: 'On the screen, you will see a form to enter the details of the card you will use for payment.',
		funcionamientoP4P2: 'This form is completely secure and complies with current regulations for online payments. Central Parkings does not have access to your card details, as it is a direct and secure communication with the payment gateway.',
		funcionamientoP5P1: 'If the payment process is completed successfully, you will see this reservation confirmation screen.',
		funcionamientoP5P2: 'The most relevant details are the reservation locator code and the QR code that will allow you to access the parking in case there is any issue with the automatic license plate reading system.',
		funcionamientoP5P3: 'You will receive an email with the reservation details. We recommend that you keep this email in case the parking staff requests it.',
		funcionamientoP6P1: 'If there are more than 24 hours until the start of your reservation, you can cancel it automatically and free of charge.',
		funcionamientoP6P2: 'Click the "CANCEL RESERVATION" button that you will find in the page\'s menu bar. When you do, a window will appear for you to enter your email and the reservation locator number. With this information, we can retrieve all the necessary details.',
		funcionamientoP6P3: 'If you are within the cancellation period and have entered the data correctly, all the information associated with the reservation will be displayed: start date and time, end date and time, amount paid, etc. By clicking the "CANCEL" button, the reservation will be cancelled and the amount paid will be refunded to your credit card.',
		mensajeCookies: 'We use our own and third-party cookies to improve the user experience and our services. If you accept or continue browsing, we consider that you agree to their use.',
		enlaceCookies: 'Cookie Policy',
		aceptarCookies: 'I Accept',
		accionesReserva: 'My reservations',
		reviseSuCorreo: 'You will receive an email with the invoice',
		correoParkingSanBernardo: ' lunadegranada@delunaparking.com'
	},

	'fr': {
		errorCaracteresMatricula: 'Uniquement des lettres et des chiffres',
		errorObteniendoDisponibilidad: 'Erreur lors de l\'obtention de la disponibilité des places.',
		plazasNoDiponibles: 'Il n\'y a pas de places disponibles aux dates indiquées.',
		obtenerFactura: 'Obtenir la facture',
		cancelarReserva: 'Annuler la réservation',
		avisolegal: 'Conditions d\'utilisation',
		politicaprivacidad: 'Politique de la protection des données personnelles',
		pagoseguro: 'Paiement sécurisé avec',
		copyright: 'Créé par',
		horario: 'Lundi au dimanche 24 heures',
		comollegar: 'COMMENT ARRIVER',
		minutos: 'minutes',
		informacionParking: 'Informations parking',
		puertobarcelona: 'Port de Barcelone',
		palaciovirreina: 'Palais de la Virreina',
		teatroliceo: 'Gran Teatre del Liceu',
		larambla: 'La Rambla',
		boqueria: 'Marché de la Boqueria',
		plazareal: 'Plaça Reial',
		direccionpuerto: 'Port de Barcelone',
		direccionpalacio: 'La Rambla, 99, 08001 Barcelona',
		direccionteatro: 'La Rambla, 51-59, 08002 Barcelona',
		direccionrambla: 'La Rambla, 08002 Barcelona',
		direccionboqueria: 'La Rambla, 91, 08001 Barcelona',
		direccionplazareal: 'Plaza Real, 9, 08002 Barcelona',
		dia: 'jour',
		dias: 'jours',
		duracion: 'DURÉE',
		importe: 'MONTANT',
		tablaTarifaDias: 'Jours',
		tablaTarifaPrecio1: 'Prix en ligne exclusif',
		tablaTarifaPrecio2: 'à partir du 3ème jour',
		tablaTarifaTitulo: 'NOTRE TARIF',
		datosReservaTitulo: 'COMPLÉTEZ VOTRE RÉSERVATION',
		datosReservaFechaEntrada: 'Date d\'entrée',
		datosReservaFechaSalida: 'Date de sortie',
		datosReservaMatricula: 'Immatriculation',
		datosReservaModelo: 'Modèle de véhicule',
		datosReservaColor: 'Couleur du véhicule',
		datosReservaCrucero: 'Croisière',
		datosReservaPrecioTotal: 'Parking rèserve',
		datosReservaTotal: 'Total',
		datosReservaNombre: 'Nom complet',
		datosReservaEmail: 'Email',
		datosReservaTelefono: 'Numéro de téléphone',
		datosReservaAceptoCondiciones: 'J\'accepte les termes et conditions du service',
		datosReservaInformacionFacturacion: 'Données de facturation',
		datosReservaNombreFac: 'Nom complet',
		datosReservaCif: 'CAF',
		datosReservaDireccion: 'Adresse',
		datosReservaLocalidad: 'Localité',
		datosReservaCp: 'Code postal',
		datosReservaLocalizador: 'Localisateur',
		datosReservaQR: 'Code QR',
		miReservaTitulo: 'Données de réservation',
		errorNoNombre: 'Données obligatoires',
		errorNoEmail: 'Données obligatoires',
		errorEmailErroneo: 'Veuillez saisir un e-mail valide',
		errorNoAceptaTerminos: 'Données obligatoires',
		errorNoTelefono: 'Données obligatoires',
		errorNoFechaEntrada: 'Données obligatoires',
		errorNoFechaSalida: 'Données obligatoires',
		errorNoMatricula: 'Données obligatoires',
		errorNoModelo: 'Données obligatoires',
		errorNoColor: 'Données obligatoires',
		errorNoCrucero: 'Données obligatoires',
		errorNoLocalizador: 'Données obligatoires',
		errorReservaNoEncontrada: 'Réserve non trouvée',
		btnBuscarReserva: 'Recherche réservation',
		btnReservar: 'Réserver',
		btnTerminar: 'Finir',
		btnImprimir: 'Imprimer',
		btnContinuar: 'Continuer',
		btnCancelar: 'Annuler',
		btnSolicitarFactura: 'Demande la facture',
		fechaFinalErronea: 'Date de fin incorrecte',
		reservaMayorPermitido: 'La réservation dépasse la durée maximale autorisée (14 jours)',
		datosReservaHoraEntrada: '',
		datosReservaHoraSalida: '',
		lugaresInteres: 'Choses à voir et à faire à proximité',
		descripcionParking: 'Description',
		descripcionParkingP1: 'Parking Barcelona Port est un parking public situé à l\'intérieur du port de Barcelone, Terminal E.',
		descripcionParkingP2: 'Vous pouvez laisser votre voiture en sécurité ainsi que profiter de vos vacances sans soucis et éviter d’avoir à rechercher un transfert. Le parking idéal si vous partez en croisière avec Costa Cruceros, Aida cruises, parmi beaucoup d’autres, car le parking se trouve à quelques minutes à pied de l’entrée des gares maritimes.',
		descripcionParkingP3: 'Grâce à notre site, vous pouvez réserver une place dans notre parking pour votre voiture pendant les dates de votre choix. De cette façon, vous vous assurez un stationnement.',
		descripcionParkingP4: ' Nous avons un total de 275 places de stationnement disponibles, et 9 places pour les personnes à mobilité réduite. Parking ouvert tous les jours, 24h/24h. Toutes nos places de stationnement sont découvertes et sont surveillées en permanence par des caméras de sécurité.',
		presentacionDireccion: 'Adresse',
		presentacionHorario: 'Horaires',
		presentacionServicios: 'Services',
		presentacionPubli: 'Réservation en ligne votre Parking Cruise Terminal Barcelone',
		presentacionAccesos: 'Accès et départs',
		presentacionDias: 'Lundi à dimanche	24 heures',
		presentacionDireccionParking: 'Derrière Terminal E - HELIX, Moll Adossat, 08039, Barcelona',
		stepperComprobarDatos: 'TES DONNÉES',
		steperRealizarPago: 'PAIEMENT',
		stepperResultadoProceso: 'RÉSERVÉ',
		resumenTitulo: 'Résumé de réservation',
		resumenPrecio: 'PRIX',
		resumenSubTotal: 'Sous total',
		resumenTotal: 'TOTAL',
		resumenPieCancelacion: 'Annulation gratuite 7 heures avant.',
		resumenPieGarantia: 'Place de parking garantie.',
		resumenAvisoDevolucion: 'Le montant sera payé sur la même carte utilisée dans le paiement',
		resumenImporteAbonado: 'Le montant payé',
		condicionesUso: 'Conditions du service',
		politicaDevolucion: ' Politique d\'Annulation et de Remboursement',
		y: 'et',
		resumenAvisoCorreo: 'Vous recevrez un mail avec tous les détails de votre réservation.',
		resumenAvisoCorreoFactura: 'Vous recevrez un e-mail avec votre facture.',
		resumenContacto: 'En cas d\'annulation ou changement de date, nous vous rappelons que c\'est entièrement gratuit GRATUITO, envoyez un mail à cpunio@smartrental.com  ou appelez au +34 911 410 171',
		stepperContinuarPago: 'Aceptar condicones y continuar con el pago',
		inicioBienvenido: 'BIENVENUE',
		inicioNombreParking: 'deLuna Parking',
		inicioReservaConNosotros: 'Si vous partez en croisière depuis le Moll Adossat dans le port de Barcelone, réservez votre place de parking avec nous. Situé à côté de la station maritime Helix Cruise Center, Terminal E.',
		inicioSomosUnicos: 'NOUS SOMMES LE SEUL PARKING DE LONG SÉJOUR SUR LE QUAI DE CROISIÈRE DU PORT DE BARCELONE',
		inicioPrecioSemana: '7 jours pour 68€',
		inicioReservarPlaza: 'Réservez votre place',
		inicioPlazaGarantizada: 'En réservant une place avec nous, votre parking au port de Barcelone est garanti.',
		inicioCancelacionReembolso: 'Si vous devez annuler votre réservation, vous pouvez le faire avec l\'option d\'un remboursement jusqu\'à 7 jours avant.',
		inicioAhorra: 'Économisez avec des tarifs compétitifs pour des séjours courts et longs.',
		inicioTituloPlazaGarantizada: 'Votre place est garantie',
		inicioTituloCancelacionReembolso: 'Annulation avec remboursement',
		inicioTituloAhorra: 'Économisez sur le stationnement',
		inicioConsulteRestricciones: 'Voir Restrictions',
		inicioZBE: 'Zone à faibles émissions',
		menuReservar: 'Réserver',
		menuFaq: 'FAQS',
		menuFuncionamiento: 'Comment ça marche?',
		menuContacto: 'Contact',
		menuCancelar: 'Annuler la réservation',
		servicioAireLibre: 'Découvert et ouvert 24 heures',
		servicioCodigoQr: 'Lecteur de plaque d\'immatriculation et code QR',
		servicioVideoVigilancia: 'Vidéosurveillance',
		servicioAlturaMaxima: 'Hauteur maximale 2,4 m',
		servicioZbe: 'Zone à faibles émissions',
		servicioPlazasMinusvalidos: 'Places mobilité réduite',
		servicioCancelacionReserva: 'Annulation gratuite jusqu\'à 7 jours avant le début de la réservation',
		listadoCruceros: 'Trouvez votre croisière',
		descripcionZBE1: 'Nous vous informons que depuis le 1er janvier la Mairie de Barcelone a mis en service la nouvelle zone à faibles émissions (ZBE) qui restreint la circulation de certains véhicules dans toute la ville. C\'est pour cette raison que pour accéder à notre parking, vous devrez vérifier si votre véhicule (immatriculation nationale ou étrangère) est autorisé à circuler dans cette zone.',
		descripcionZBE2: 'Nous attachons le lien vers le site officiel de la Mairie de Barcelone, afin vous puissiez accéder à toutes les informations et où vous pourrez vous inscrire si nécessaire.',
		preguntasFrecuentes: 'Questions fréquentes',
		pregunta1: 'Comment accédez-vous au parking?',
		pregunta1Parrafo1: 'Si vous avez réservé via notre site Web, il vous suffit de vous approcher de la barrière avec votre véhicule et celle-ci s\'ouvrira automatiquement. Notre système lira votre plaque d\'immatriculation avec une caméra. C’est pour cette raison qu’il est important de vous assurer d’enregistrer votre immatriculation de voiture correctement.',
		pregunta1Parrafo2: 'Dans le cas où le lecteur ne lirait pas correctement votre plaque d’immatriculation, vous pouvez y accéder en utilisant le code QR qui vous sera envoyé par email lors de votre réservation. Vous pouvez le prendre imprimé ou sur votre mobile',
		pregunta1Parrafo3: 'Si la barrière n\'est pas ouverte automatiquement pour une raison quelconque, vous pouvez contacter directement la direction du stationnement en appuyant sur le bouton orange INFORMATION.',
		pregunta2: 'Comment puis-je sortir du parking?',
		pregunta2Parrafo1: 'Si vous avez réservé via notre site Web, il vous suffit de vous approcher de la barrière avec votre véhicule et celle-ci s\'ouvrira automatiquement. Notre système lira votre plaque d\'immatriculation avec une caméra. C’est pour cette raison qu’il est important de vous assurer d’enregistrer votre immatriculation de voiture correctement.',
		pregunta2Parrafo2: 'Dans le cas où le lecteur ne lirait pas correctement votre plaque d’immatriculation, vous pouvez y accéder en utilisant le code QR qui vous sera envoyé par email lors de votre réservation. Vous pouvez le prendre imprimé ou sur votre mobile',
		pregunta2Parrafo3: 'Si la barrière n\'est pas ouverte automatiquement pour une raison quelconque, vous pouvez contacter directement la direction du stationnement en appuyant sur le bouton orange INFORMATION.',
		pregunta3: 'Pouvez-vous vous garer dans n\'importe quel espace?',
		pregunta3Parrafo1: 'Oui, la réservation concerne tout espace actuellement libre au moment où vous le souhaitez. Plusieurs baies sont réservées aux personnes à mobilité réduite.',
		pregunta3Parrafo2: '',
		pregunta3Parrafo3: '',
		pregunta4: 'Puis-je récupérer le véhicule après la fin de la réservation en ligne?',
		pregunta4Parrafo1: 'Si vous ne pouvez pas venir chercher votre véhicule au moment de la fin de la réservation en ligne, nous vous conseillons de contacter la direction du stationnement en appuyant sur le bouton orange INFORMATION. Prolonger une réservation est possible tant qu\'il y a de la disponibilité.',
		pregunta4Parrafo2: '',
		pregunta4Parrafo3: '',
		pregunta5: 'Si j\'arrive avant l\'heure réservée, pourrai-je entrer?',
		pregunta5Parrafo1: 'Nous conseillons à nos clients d\'arriver à l\'heure réservée, mais nous comprenons que ce n\'est pas toujours possible et, par conséquent, nous avons un temps de courtoisie raisonnable (1 heure avant et 1 heure après leur réservation). Si à l\'arrivée, la barrière ne s\'ouvre pas automatiquement, ou via le code QR, vous devrez contacter l\'administration du parking en appuyant sur le bouton orange INFORMATION. L\'accès sera accordé sous réserve de disponibilité.',
		pregunta5Parrafo2: '',
		pregunta5Parrafo3: '',
		pregunta6: 'Puis-je modifier l\'inscription une fois la réservation effectuée?',
		pregunta6Parrafo1: 'Oui, veuillez envoyer une demande de modification à: cpunio@smartrental.com , en indiquant le code de réservation et l\'enregistrement seront modifiés afin que vous n\'ayez aucun problème pour accéder au parking.',
		pregunta6Parrafo2: '',
		pregunta6Parrafo3: '',
		pregunta7: 'Le parking est-il facile à trouver?',
		pregunta7Parrafo1: 'Le parking est le seul parking de longue durée sur le quai de croisière. Notre parking a des barrières d’entrée et de sortie et il est situé juste au-delà du Terminal Helix (Terminal E). Voir notre carte sur le site pour plus d\'informations. Assurez-vous de ne pas laisser votre véhicule stationné dans des zones non autorisées à l’extérieur de notre parking car il sera remorqué ou sous sabot d\'immobilisation par l’autorité portuaire.',
		pregunta7Parrafo2: '',
		pregunta7Parrafo3: '',
		pregunta8: 'Combien de temps à l\'avance dois-je effectuer ma réservation en ligne pour bénéficier du meilleur prix?',
		pregunta8Parrafo1: 'Si des places sont disponibles, vous pouvez réserver jusqu\'à deux heures avant votre arrivée.',
		pregunta8Parrafo2: '',
		pregunta8Parrafo3: '',
		pregunta9: 'Le parking est-il près de mon paquebot?',
		pregunta9Parrafo1: 'Le quai de croisière Adossat est le quai où se trouvent les 5 terminaux de croisière du port de Barcelone.',
		pregunta9Parrafo2: 'Si vous savez à quel terminal votre paquebot accostera, ',
		pregunta9link: 'cliquez ici',
		pregunta9Parrafo3: ' pour connaître la distance de marche entre votre terminal et le parking.',
		pregunta10: 'Quelles sont les dimensions maximales du véhicule acceptées par le parking?',
		pregunta10Parrafo1: 'L\'accès est limité par une largeur maximale de 300 cm et une hauteur libre de 240 cm. La taille de chaque espace est de 490x240 cm. Les bus, les grandes caravanes, les véhicules avec remorques, etc. ne sont pas autorisés.',
		pregunta10Parrafo2: 'Les places pour les personnes à mobilité réduite sont adaptées à la législation correspondante.',
		pregunta10Parrafo3: '',
		pregunta11: 'Y a-t-il une station de charge électrique?',
		pregunta11Parrafo1: 'Non, pour le moment nous n\'avons pas ce service.',
		pregunta11Parrafo2: '',
		pregunta11Parrafo3: '',
		pregunta12: 'Y a-t-il un service de nettoyage?',
		pregunta12Parrafo1: 'Non, pour le moment nous n\'avons pas ce service.',
		pregunta12Parrafo2: '',
		pregunta12Parrafo3: '',
		pregunta13: 'Le parking est-il gardé?',
		pregunta13Parrafo1: 'Le parking est surveillé par CCTV video surveillance. L\'accès à la zone du quai de croisière (où se trouve le parking) est limité par la police du port et lorsqu\'il n\'y a pas de paquebot l\'accès au quai de croisière Adossat au personnel non autorisé n\'est pas autorisé. Les patrouilles de la police du port sont constantes dans cette zone.',
		pregunta13Parrafo2: '',
		pregunta13Parrafo3: '',
		pregunta14: 'Le garage est-il couvert?',
		pregunta14Parrafo1: 'Non, c\'est un parking a l’air libre.',
		pregunta14Parrafo2: '',
		pregunta14Parrafo3: '',
		pregunta15: 'Existe-t-il un service de garde des clés?',
		pregunta15Parrafo1: 'Non, veuillez garder vos clés sur vous car nous n\'offrons pas ce service.',
		pregunta15Parrafo2: '',
		pregunta15Parrafo3: '',
		pregunta16: 'Que se passe-t-il si je perds le billet?',
		pregunta16Parrafo1: 'Vous trouverez des instructions au GAB',
		pregunta16Parrafo2: '',
		pregunta16Parrafo3: '',
		reservaConfirmada: 'RÉSERVATION CONFIRMÉE',
		infoTiempoCortesia: 'Vous disposerez d\'une marge d\'entrée / sortie d\'une heure par rapport à l\'heure de réservation effective.',
		tablaTarifaDiaPorHoras: 'Une jour',
		tablaTarifaHoras: 'Une heure',
		tablaTarifaHorasTitulo: 'Frais de stationnement standard',
		tablaTarifaHorasPrecio: 'Montant',
		reservaCancelada: 'La réservation a été annulée et le montant payé sur la carte de crédit',
		datosReservaTarjeta: 'Carte de crédit',
		errorPlazoCancelacion: 'Votre réservation commence dans moins de 7 jours et ne peut être annulée par ce moyen.',
		funcionamientoEstancia: 'Définit la période de réservation',
		funcionamientoDatosPersonales: 'Identifiez-vous',
		funcionamientoDatosFacturacion: 'Aurez-vous besoin d\'une facture?',
		funcionamientoPago: 'Effectuer le paiement de la réservation',
		funcionamientoReservaRealizada: 'Félicitations, vous avez terminé votre réservation.',
		funcionamientoCancelarReserva: 'Voulez-vous annuler votre réservation?',
		funcionamientoP1P1: 'Saisissez les données qui définissent la période de la réservation (jour/heure d\'entrée et jour / heure de départ), les informations du véhicule que vous allez utiliser (numéro d\'immatriculation, modèle et couleur) et la croisière sur laquelle vous embarquerez. Une partie de ces données est requisé par l\'Autorité Portuaire pour des raisons de sécurité.',
		funcionamientoP1P2: 'Notre site Internet vous informera du montant à payer pour la période saisie. Un avertissement peut s\'afficher si la date de départ n\'est pas postérieure à la date d\'arrivée.',
		funcionamientoP1P3: 'Veuillez noter que les frais de réservation en ligne s\'appliquent aux journées complètes. Si vous sélectionnez moins de 24 heures, un jour de séjour vous sera facturé; si vous dépassez 24 heures pendant une minute, vous serez facturé deux jours.',
		funcionamientoP1P4: 'Appuyez sur le bouton "RÉSERVER" pour continuer le processus.',
		funcionamientoP2P1: 'Nous devons connaître un minimum d\'informations vous concernant. De cette façon, nous pourrons avoir un canal de communication avec vous et vous identifier au cas où vous auriez besoin de nous le demander.',
		funcionamientoP3P1: 'Si vous pensez que vous aurez besoin d\'une facture nominale pour votre séjour, entrez les informations de facturation fiscale. Ce n\'est pas obligatoire.',
		funcionamientoP4P1: 'Sur l\'écran, vous verrez un formulaire pour entrer les données de la carte avec laquelle vous allez effectuer le paiement.',
		funcionamientoP4P2: 'Ce formulaire est entièrement sécurisé et conforme à la réglementation en vigueur pour les paiements en ligne. Parking Barcelona Port n\'a pas accès aux données de votre carte, car il s\'agit d\'une communication directe et securisée avec la plate-forme de paiement.',
		funcionamientoP5P1: 'Si le processus de paiement se termine correctement, vous verrez cet écran de confirmation de réservation.',
		funcionamientoP5P2: 'Les données les plus pertinentes sont le code de localisation de réservation et le code QR qui seront utilisés pour accéder au parking en cas de problème avec le système de lecture automatique des plaques d\'immatriculation.',
		funcionamientoP5P3: 'Vous recevrez un e-mail avec les informations de réservation. Nous vous recommandons de conserver cet e-mail au cas où les employés du parking le demanderaient.',
		funcionamientoP6P1: 'S\'il reste plus de 7 jours avant le début de votre réservation, vous pouvez l\'annuler automatiquement et gratuitement.',
		funcionamientoP6P2: 'Appuyez sur le bouton "ANNULER LA RESERVATION" que vous trouverez dans la barre de menu de la page. Lorsque vous le faites, une fenêtre apparaîtra pour vous permettre de saisir votre e-mail et le numéro du localisateur de réservation. Avec ces données, nous pouvons récupérer toutes les informations nécessaires.',
		funcionamientoP6P3: 'Si vous êtes dans la période d\'annulation et que vous avez correctement saisi les données, toutes les informations associées à la réservation seront affichées: date et heure de début, date et heure de fin, montant payé, etc. Appuyer sur le bouton «ANNULER» annulera la réservation dans le parking et remboursera le montant payé sur votre carte de crédit.',

		mensajeCookies: 'Nous utilisons nos propres cookies et ceux de tiers pour améliorer l\'expérience utilisateur et améliorer nos services. Si vous acceptez ou continuez à naviguer, nous considérons que vous acceptez leur utilisation.',
		enlaceCookies: 'Politique de cookies',
		aceptarCookies: 'Je suis d\'accord',
		accionesReserva: 'Mes réservations',
		reviseSuCorreo: 'Vous recevrez un email avec votre facture'


	},	// fin traduccion a frances

	'ca': {
		proximamente: "Properament",
		rellenaElFormulario: 'Omple el següent formulari',
		quieresTrabajar: "Vols treballar amb nosaltres?",
		labelCiudadSeleccionada: "Ciutat seleccionada",
		labelParkingSeleccionado: "Parking seleccionada",
		aseos: 'Lavabos',
		ciudad: 'Ciutat',
		accede: "Clica aquí.",
		electrico: 'Càrrega elèctrica *',
		atencion: 'Atenció 24 hores *',
		pago: 'Pagament contactless, Targeta i Efectiu',
		trabajaconnosotros: 'Treballa amb nosaltres',
		labelInicio: 'On et trobes?',
		servicioZbeBarcelona: 'Zona de baixes emissions a Barcelona',
		servicioZbeMadrid: 'Zona de baixes emissions a Madrid',
		labelInicioDondeQuieresAparcar: 'On vols aparcar?',
		terminosPrivacidadCurriculum: 'Accepta els termes de privadesa',
		eligeCiudad: 'Trieu la ciutat',
		eligeParking: 'Tria la pàrquing',
		nuestrosParking: 'Els nostres Parkings',
		reglasInicio: 'Necessites introduir aquest valor per continuar',
		errorCaracteresMatricula: 'Només lletres i números',
		errorObteniendoDisponibilidad: 'Error obtenint la disponibilitat de places.',
		plazasNoDiponibles: 'No hi ha places disponibles per a les dates marcades.',
		obtenerFactura: 'Obtenir factura',
		cancelarReserva: 'Cancel·lar reserva',
		avisolegal: 'Termes del servei',
		politicaprivacidad: 'Política de Privacitat',
		pagoseguro: 'Pagament segur amb',
		copyright: 'Creat per',
		horario: 'Dilluns a diumenge 24 hores',
		informacionParking: "Informació de l'aparcament",
		comollegar: 'COM ARRIBAR',
		minutos: 'minuts',
		puertobarcelona: 'Port de Barcelona',
		palaciovirreina: 'Palau de la Virreina',
		teatroliceo: 'Grand teatre del Liceu',
		larambla: 'La Rambla',
		boqueria: 'Mercat de la Boqueria',
		plazareal: 'Plaça Reial',
		direccionpuerto: 'Port de Barcelona',
		direccionpalacio: 'La Rambla, 99, 08001 Barcelona',
		direccionteatro: 'La Rambla, 51-59, 08002 Barcelona',
		direccionrambla: 'La Rambla, 08002 Barcelona',
		direccionboqueria: 'La Rambla, 91, 08001 Barcelona',
		direccionplazareal: 'Plaça Reial, 9, 08002 Barcelona',
		dia: 'dia',
		dias: 'dies',
		duracion: 'DURADA',
		importe: 'IMPORT',
		tablaTarifaDias: 'Dies',
		tablaTarifaPrecio1: 'Preu exclusiu online',
		tablaTarifaPrecio2: 'a partir del 3er dia',
		tablaTarifaTitulo: 'LA NOSTRA TARIFA',
		datosReservaTitulo: 'COMPLETA LA TEVA RESERVA',
		datosReservaFechaEntrada: 'Data d\'entrada',
		datosReservaFechaSalida: 'Data de sortida',
		datosReservaMatricula: 'Matrícula',
		datosReservaModelo: 'Model de vehicle',
		datosReservaColor: 'Color de vehicle',
		datosReservaCrucero: 'Creuer',
		datosReservaPrecioTotal: 'Reserva de parking',
		datosReservaTotal: 'Total',
		datosReservaNombre: 'Nom complet',
		datosReservaEmail: 'Email',
		datosReservaTelefono: 'Número de telèfon',
		datosReservaAceptoCondiciones: 'Accepto els termes i condicions de l\'servei',
		datosReservaInformacionFacturacion: 'Dades de facturació',
		datosReservaNombreFac: 'Nom complet',
		datosReservaCif: 'CIF',
		datosReservaDireccion: 'Direcció',
		datosReservaLocalidad: 'Localitat',
		datosReservaCp: 'Codi postal',
		datosReservaLocalizador: 'Localitzador',
		datosReservaQR: 'Códi QR',
		miReservaTitulo: 'Dades de la reserva',
		errorNoNombre: 'Dada obligatòria',
		errorNoEmail: 'Dada obligatòria',
		errorEmailErroneo: 'Introduïu un email vàlid',
		errorNoAceptaTerminos: 'Dada obligatòria',
		errorNoTelefono: 'Dada obligatòria',
		errorNoFechaEntrada: 'Dada obligatòria',
		errorNoFechaSalida: 'Dada obligatòria',
		errorNoMatricula: 'Dada obligatòria',
		errorNoModelo: 'Dada obligatòria',
		errorNoColor: 'Dada obligatòria',
		errorNoCrucero: 'Dada obligatòria',
		errorNoLocalizador: 'Dada obligatòria',
		errorReservaNoEncontrada: 'Reserva no trobada',
		btnBuscarReserva: 'Cercar reserva',
		btnReservar: 'Reservar',
		btnTerminar: 'Acabar',
		btnImprimir: 'Imprimir',
		btnContinuar: 'Continuar',
		btnCancelar: 'Cancel',
		btnSolicitarFactura: 'Sol·licitar factura',
		fechaFinalErronea: 'Fecha final errónea',
		reservaMayorPermitido: 'La reserva supera la durada màxima permesa (14 dies)',
		datosReservaHoraEntrada: '',
		datosReservaHoraSalida: '',
		descripcionZBEMadrid3: 'Accedeix aquí per consultar les restriccions que pugui tenir el teu vehicle. ',
		descripcionZBEMadrid1: "La Zona de Baixes Emissions d'Especial Protecció (ZBEDEP) Districte Centre va ser creada en desenvolupament de l'Estratègia de Sostenibilitat Ambiental Madrid 360, per protegir la salut humana i el medi ambient urbà mitjançant la millora de la qualitat de l'aire i la disminució de els efectes negatius del trànsit motoritzat",
		descripcionZBEMadrid2: "A aquests efectes, es prohibeix l'accés als vehicles amb classificació ambiental “A” (i que, per tant, no poden obtenir distintiu ambiental), mentre que els vehicles amb classificació ambiental “B” i “C” tenen prohibit accedir a la ZBEDEP 'Districte Centre' únicament per travessar-la, si bé ho podran fer per estacionar en un aparcament d'ús públic o privat, o reserva d'estacionament situats al seu interior. En tot cas, els criteris daccés preveuen determinades excepcions, que afecten residents, empreses i autònoms, persones amb mobilitat reduïda, serveis públics, transport dalumnat a centres educatius i altres col· lectius i supòsits.",
		servicios: "Serveis",
		lugaresInteres: 'Punts pròxims',
		descripcionParking: 'Descripció',
		descripcionParkingP1: 'Central Parkings us ofereix aparcaments privats situats estratègicament al centre la ciutat i comoditat garantida per aparcar el vostre vehicle amb totes les facilitats.',
		descripcionParkingP2: 'Disposem de tarifes econòmiques i podeu reservar per dia o bé treure bons de 3, 5 o 7 nits. També pots aparcar per hores, ho posem tot a la teva disponibilitat perquè la teva experiència sigui la millor!',
		descripcionParkingP3: "Pots reservar la teva plaça amb l'antelació que vulguis, amb Central Parkings obtindràs el millor preu garantit.",
		descripcionParkingP4: 'Tenim atenció al client les 24 hores.',
		presentacionDireccion: 'Direcció',
		presentacionHorario: 'Horaris',
		presentacionServicios: 'Servei',
		presentacionPubli: "Reserva online el teu aparcament al centre de les principals ciutats d'Espanya",
		presentacionInfo:'Del 03/07 al diumenge 07/07, el pàrquing només podrà utilitzar-se des de la 07:00 a les 15:00.',
		presentacionAccesos: 'Accessos i sortides',
		presentacionDias: 'Dilluns a diumenge 24 hores',
		presentacionDireccionParking: 'Darrere Terminal E - HELIX, Moll Adossat, 08039, Barcelona',
		stepperComprobarDatos: 'TEVES DADES',
		steperRealizarPago: 'PAGAMENT',
		stepperResultadoProceso: 'RESERVA',
		resumenTitulo: 'Resum de reserva',
		resumenPrecio: 'PREU',
		resumenSubTotal: 'Subtotal',
		resumenTotal: 'TOTAL',
		resumenPieCancelacion: 'Cancel·lació gratuïta 7 hores abans.',
		resumenPieGarantia: 'Plaça d’aparcament garantida.',
		resumenAvisoDevolucion: 'L\'import s\'abonarà en la mateixa targeta utilitzada en el pagament',
		resumenImporteAbonado: 'Import abonat',
		condicionesUso: 'Condicions de serveis',
		politicaDevolucion: ' Política de Cancel·lació i Reemborsament',
		y: 'y',
		resumenAvisoCorreo: 'Rebràs un correu electrònic amb tots els detalls de la reserva.',
		resumenAvisoCorreoFactura: 'Rebràs un email amb la teva factura.',
		resumenContacto: 'En cas que vulguis corregir qualsevol detall després de la seva reserva, per favor contacta amb nosaltres a parking@bct.com',
		stepperContinuarPago: 'Aceptar condicones y continuar con el pago',
		inicioBienvenido: 'BENVINGUT',
		inicioNombreParking: 'deLuna Parking',
		inicioReservaConNosotros: 'Si surts en un creuer des del Moll Adossat del port de Barcelona, reserva la teva plaça de parking amb nosaltres. Situat al costat de l\'Helix Cruise Center, Terminal E.',
		inicioSomosUnicos: 'SOM L\'ÚNIC PARKING DE LLARGA ESTADA AL MOLL DE CREUERS DEL PORT DE BARCELONA',
		inicioPrecioSemana: '7 dies per només 68€',
		inicioReservarPlaza: 'Reserva la teva plaça',
		inicioPlazaGarantizada: 'Reservant una plaça amb nosaltres, el teu aparcament està garantit.',
		inicioCancelacionReembolso: 'Si necessites cancel·lar la teva reserva, podràs fer-ho amb opció a reemborsament fins a 24 hores abans.',
		inicioAhorra: 'Estalvia amb tarifes competitives per a estada curta i llarga.',
		inicioTituloPlazaGarantizada: 'La teva plaça està garantida',
		inicioTituloCancelacionReembolso: 'Cancel·lació amb reemborsament',
		inicioTituloAhorra: 'Estalvia en parking',
		inicioConsulteRestricciones: 'Consulteu Restriccions',
		inicioZBE: 'Zona de Baixes Emissions',
		menuReservar: 'Reservar',
		menuFaq: 'FAQS',
		menuFuncionamiento: 'Com funciona?',
		menuContacto: 'Contacte',
		menuCancelar: 'cancel·lar reserva',
		servicioAireLibre: 'Descobert i obert 24h',
		servicioCodigoQr: 'Lector de matrícules i codi QR',
		servicioVideoVigilancia: 'Videovigilància',
		servicioAlturaMaxima: 'Alçada màxima 2,4m',
		servicioZbe: 'Zona de baixes emissions',
		servicioPlazasMinusvalidos: 'Places per a minusvàlids',
		servicioCancelacionReserva: "Cancel·lació gratuïta fins a 24 hores abans de l'inici de la reserva. (* només pàrquings de Madrid)",
		listadoCruceros: 'Troba el teu creuer',
		descripcionZBE1: 'Els informem que des de l\'1 de gener l\'Ajuntament de Barcelona ha posat en funcionament la nova zona de baixes emissions (ZBE) que restringeix la circulació de certs vehicles per la ciutat. És per aquest motiu que per accedir al nostre estacionament hauran de comprovar si el seu vehicle (matrícula nacional o estrangera) està autoritzat per poder circular en aquesta zona.',
		descripcionZBE2: 'Adjuntem el link de la pàgina oficial de l\'Ajuntament de Barcelona, perquè puguin accedir a tota la informació on podran registrar en cas de ser necessari.',
		preguntasFrecuentes: 'Preguntes freqüents',
		pregunta1: 'Com s\'accedeix al parking?',
		pregunta1Parrafo1: 'Les portes del nostre pàrquing romandran obertes 24 hores, per la qual cosa només ha de presentar la seva reserva al nostre company o sol·licitar disponibilitat.',
		pregunta2: 'Com surto del parking?',
		pregunta2Parrafo1: 'Un cop hagueu abonat la vostra estada, podreu adreçar-vos al vostre cotxe, passar el comprovant de pagament pel nostre lector i sortir del nostre pàrquing.',
		pregunta3: 'Es pot aparcar a qualsevol plaça?',
		pregunta3Parrafo1: 'Només podrà aparcar a les places habilitades per fer-ho',
		pregunta4: "Puc retirar el cotxe més tard de l'hora que tenia reservada?",
		pregunta4Parrafo1: "Sí, només haurà d'abonar la diferència, ja que el comprovant no funcionarà, i sempre subjecte a disponibilitat",
		pregunta5: 'Si arribo abans de l\'hora reservada, podré entrar?',
		pregunta5Parrafo1: 'Per descomptat, sempre que hi hagi disponibilitat',
		pregunta6: 'El pàrquing és a prop del Gran Teatre del Liceu?',
		pregunta6Parrafo1: 'Sí, a 2 minuts a peu.',
		pregunta7: 'Quina alçada té el pàrquing?',
		pregunta7Parrafo1: 'Alçada max 225 cm.',
		pregunta8: 'Hi ha estació de recàrrega elèctrica?',
		pregunta8Parrafo1: 'Sí, podeu carregar el seu vehicle aquí.',
		pregunta9: 'Hi ha servei de neteja?',
		pregunta9Parrafo1: 'Sí, podeu netejar el vostre vehicle per 30 €, sempre que hi hagi disponibilitat.',
		pregunta10: 'puc reservar la meva plaça?',
		pregunta10Parrafo1: "A través de la nostra web oa través de l'APP.",
		pregunta11: 'Mètodes de pagament?',
		pregunta11Parrafo1: 'Únicament podrà pagar a través de la nostra web o amb targeta de crèdit a les nostres màquines habilitades per fer-ho.',
		pregunta12: 'Puc aparcar la meva moto?',
		pregunta12Parrafo1: "Sí, la tarifa és igual a la d'un turisme.",
		reservaConfirmada: 'RESERVA CONFIRMADA',
		infoTiempoCortesia: 'Disposarà d\'un marge d\'entrada / sortida d\'una hora respecte a el temps efectiu de servei.',
		tablaTarifaDiaPorHoras: 'Un dia',
		tablaTarifaHoras: 'Una hora',
		tablaTarifaHorasTitulo: 'Tarifa estàndard d\'estacionament',
		tablaTarifaHorasPrecio: 'Import',
		reservaCancelada: 'La reserva ha estat cancel·lada i el seu import abonat a la targeta de crèdit',
		datosReservaTarjeta: 'Targeta de crèdit',
		errorPlazoCancelacion: "La reserva comença en menys d'1 dia i no pot ser cancel·lada per aquest mitjà.",
		funcionamientoEstancia: 'Defineix el període de reserva',
		funcionamientoDatosPersonales: 'Identifica\'t',
		funcionamientoDatosFacturacion: 'Necessitaràs una factura?',
		funcionamientoPago: 'Realitza el pagament de la reserva',
		funcionamientoReservaRealizada: 'Enhorabona, has acabat la teva reserva.',
		funcionamientoCancelarReserva: 'Vols cancel·lar la teva reserva?',
		fechaAnterior: "Data d'entrada incorrecta",
		fechaAnteriorDescripcion: "La data d'entrada seleccionada és anterior a l'hora actual. Si us plau, emplena correctament els camps.",
		funcionamientoP1P1: "Introdueix les dades que defineixen el període de la reserva (dia/hora d'entrada i dia/hora de sortida), la informació del vehicle que utilitzaràs (número de matrícula, model).",
		funcionamientoP1P2: 'La nostra web t\'informarà de l\'import a pagar per al període de temps introduït. Pot aparèixer un avís en cas que la data de sortida no sigui posterior a la d\'entrada.',
		funcionamientoP1P3: 'Prem el botó "RESERVAR" per continuar amb el procés.',
		funcionamientoP1P4: '',
		funcionamientoP2P1: 'Necessitem conèixer una informació mínima sobre tu, d\'aquesta manera podrem tenir un canal de comunicació amb tu i identificar-te en cas que necessitis realitzar-nos alguna consulta.',
		funcionamientoP3P1: 'Si creus que necessitaràs una factura nominativa de la teva estada, introdueix les dades fiscals de facturació. No és obligatori.',
		funcionamientoP4P1: 'En pantalla veuràs un formulari per introduir les dades de la targeta amb la qual vas a realitzar el pagament.',
		funcionamientoP4P2: "Aquest formulari és totalment segur i compleix la normativa vigent per a pagaments per internet. Central Parkings no té accés a les dades de la targeta, ja que es tracta d'una comunicació directa i blindada amb la passarel·la de pagaments.",
		funcionamientoP5P1: 'Si el procés de pagament conclou correctament veuràs aquesta pantalla de confirmació de reserva.',
		funcionamientoP5P2: 'Les dades més rellevants són el codi del localitzador de la reserva i el codi QR que et servirà per accedir a l\'aparcament en cas que hi hagués algun problema amb el sistema automàtic de lectura de matrícula.',
		funcionamientoP5P3: 'Rebràs un email amb les dades de la reserva. Et recomanem que conservis aquest mail per si te’l demanen els empleats de l\'aparcament.',
		funcionamientoP6P1: "Si falten més de 24 hores fins al moment d'inici de la reserva, pots cancel·lar-la de manera automàtica i gratuïta.",
		funcionamientoP6P2: 'Prem el botó "CANCEL·LAR RESERVA" que trobareu a la barra de menú de la pàgina. Quan ho facis apareixerà una finestra per introduir el teu email i el número de localitzador de la reserva. Amb aquestes dades podrem recuperar tota la informació necessària.',
		funcionamientoP6P3: 'Si estàs en termini de cancel·lació i has introduït correctament les dades, se\'t mostrarà tota la informació associada a la reserva: Data i hora d\'inici, data i hora de finalització import pagat, etc. Prement el botó "CANCEL·LAR" s\'anul·larà la reserva al parking i se\'t retornarà l\'import pagat a la targeta de crèdit.',
		enviar: "Enviar",
		correoParkingGranVia: ' cpgranvia@madrid4rentals.com',
		cerrar: "Tancar",
		nombre: 'Nom',
		apellidos: "Cognoms",
		telefono: "Telefono",
		adjuntaCurriculum: "Adjunta el teu currículum",
		falloCurriculum: "Fallada en enviar el currículum",
		falloCurriculumDescripcion: "Omple correctament totes les dades per enviar el currículum",
		fechasIncorrectas: "Dates incorrectes",
		fechasIncorrectasDescripcion: "Heu introduït les dates incorrectament",
		envioCorrecto: "Enviament correcte",
		envioCorrectoDescripcion: "S'ha enviat el currículum correctament.",
		mensajeCookies: 'Utilitzem cookies pròpies i de tercers per millorar l\'experiència d\'usuari i millorar els nostres serveis. Si accepta o continua navegant, considerem que accepta el seu ús.',
		enlaceCookies: 'Política de cookies',
		aceptarCookies: 'Estic d\'acord',
		accionesReserva: 'Les meves reserves',
		correoParkingSanBernardo: ' cpsanbernardo@madrid4rentals.com',
		reviseSuCorreo: 'Rebreu un correu electrònic amb el vostre fet',
		proximamenteAbierto: "Properament obert",
		datosReservaPromocion: 'Codi promocional',
		tienesCodigoPromocional: 'Usar codi de promoció',
		descuentoCodigoPromocional: 'Descompte',
		codigoPromocionalNoValido: 'Codi promocional incorrecte',
		codigoPromocionalUsado: 'Aquest codi ja ha estat usat',
		codigoPromocionalValido: 'Codi promocional  vàli',
		codigoPromocionalMinimo: 'Codi promocional vàlid, per activar-lo cal fer una reserva amb més dies.',
		tituloFraude: 'Fallada en obtenir les dades de pagament',
		losMasBaratos: 'SOM ELS MÉS BARATS DE LA ZONA',
		contactoGV: "Central Parking GV 14 és un Parking cobert al centre de Madrid amb 40 places disponibles, dividides en 4 plantes i obert 24 hores amb vigilància. Disposa de 5 places de càrrega elèctrica i 2 places de minusvàlid. Està situat al carrer Reina 14 amb sortida de vianants al carrer Gran Via 14 ( Ascensors a cada planta ), a un pas del Museu Chicote i el Casino Gran Via. On podrà gaudir dels teatres, Teatre Coliseum, Teatre Rialto, Teatre Lope de Vega. El Tall anglès, Primark, Zara.",
		contactoGVTurismo: "Turisme: Monestir de les descalces reals, Espai fundació Telefònica, Edifici Telefònica, Carrer de la Montera, Plaça Pedro Cerolo, Església de Sant Josep, Institut Cervantes, la Central de Callao, Plaça del Carme, Carrer dels Llibreters, Edifici Grassy ,Cercle de Belles Arts i per descomptat La Cibeles amb el Banco España al costat.",
		descripcionFraude: 'Hem detectat una fallada en obtenir dades del pagament. Torneu a intertar-ho si us plau.',
		codigoPromocionalCaducado: 'Codi promocional no vàlid, aquest codi està caducat',
		contactoUnio1: "Central Parking Ramblas és un Parking cobert al centre de Barcelona amb 94 places disponibles, dividides en 4 plantes i obert 24 hores amb vigilància. Està situat a un pas de la Rambla exactament a 60 metres, entre el Raval i el Barri Gòtic de Barcelona i entre d'altres llocs d'interès podrem trobar a 2 minuts a peu el Gran Teatre del Liceu, a 120 metres del Palau Guell a 400 metres. de Mercat de la Boqueria, a 3 minuts a peu de la Plaça Reial ia 2 km de la platja",
		contactoUnio: "Central Pàrquing Rambles és un Pàrquing en el centre de Barcelona amb 94 places disponibles, dividides en 4 plantes i obert 24 hores amb vigilància. Està situat a un pas de la Rambla exactament a 60 metres, entre el Raval i el barri Gòtic de Barcelona i entre altres llocs d'interés podrem trobar a 2 minuts a peu el Gran Teatre del Liceu, a 120 metres del Palau Güell a 400 metres del Mercat de la Boqueria, a 3 minuts a peu de la Plaça Reial i a 2 km de la platja.",
		contactoSB: 'Parking con doble carril para entrada y salida, 62 plazas disponibles. 2 plazas de minusválidos. Altura máxima del parking 2,15m. Cajero en la primera planta. Acceso peatonal por escaleras y ascensor.',
	}	// fin traduccion a catalan
};

export default new VueI18n({
	locale: 'es', 			// set locale
	fallbackLocale: 'es', 	// set fallback locale
	messages 				// set locale messages
});
